import { Text as RNText, View } from 'react-native';

import { cn } from '@/lib/design-system/cn';
import { labelColor, type LabelColor } from '@/lib/design-system/label-color';

/**
 * Currency chip. Colour comes from the shared label palette: pass an explicit
 * `color` (e.g. from `distinctLabelColors` over the currency set) so siblings
 * never repeat a hue; otherwise it falls back to a stable per-code colour.
 */
export function CurrencyBadge({
  code,
  color,
  className,
}: {
  code: string;
  color?: LabelColor;
  className?: string;
}) {
  const resolved = color ?? labelColor(code);
  return (
    <View className={cn('self-start rounded px-1.5 py-0.5', resolved.bg, className)}>
      <RNText className={cn('text-[11px] font-semibold', resolved.text)}>{code}</RNText>
    </View>
  );
}
